export default function GoogleMapsAddressLink({ linkText, address }) {
  return (
    <a
      href={
        `https://www.google.com/maps/search/?api=1&query=` +
        encodeURIComponent(address)
      }
      target="_blank"
      rel="noopener noreferrer"
      className="underline hover:cursor-pointer"
      data-testid="google-maps-address-link"
    >
      {linkText}
    </a>
  )
}